import { useCallback } from 'react'

interface SwitchInputProps {
  id?: string
  name: string
  checked: boolean
  label: string
  description?: string
  disabled?: boolean
  onChange: (name: string, checked: boolean) => void
}

export const SwitchInput = ({
  id,
  name,
  checked,
  label,
  description,
  disabled = false,
  onChange,
}: SwitchInputProps) => {
  const handleChange = useCallback(() => {
    if (!disabled) {
      onChange(name, !checked)
    }
  }, [checked, disabled, name, onChange])

  return (
    <div className={`switch-input ${disabled ? 'disabled' : ''}`}>
      <div className="switch-content">
        <div className="switch-label">{label}</div>
        {description && <div className="tiny muted">{description}</div>}
      </div>
      <button
        id={id}
        type="button"
        className={`switch ${checked ? 'on' : ''}`}
        aria-pressed={checked}
        disabled={disabled}
        onClick={handleChange}
      />
    </div>
  )
}
